import {useQuery} from '@tanstack/react-query';
import {rqCreateRequest, rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_DELETE_EMPLOYEE_REPORT_API,
  RQ_GET_EFFORT_REPORTS_API,
  RQ_GET_EMPLOYEE_DATE_WISE_API, RQ_GET_MIQNAF_EFFORT_REPORTS_API, RQ_GET_MYOWN_EFFORT_REPORTS_API,
  RQ_GET_NEW_EFFORT_REPORTS_API,
} from '@app/reactQuery/apis/constants';

export const RQUseGetEffortReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_effort_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_EFFORT_REPORTS_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetMiqnafEffortReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_miqnaf_effort_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MIQNAF_EFFORT_REPORTS_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetMyOwnEffortReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_myown_effort_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MYOWN_EFFORT_REPORTS_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetNewEffortReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_new_effort_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_NEW_EFFORT_REPORTS_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQGetEmployeeDateWiseReport = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_employee_date_wise_report', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, yyyyMmDd} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_EMPLOYEE_DATE_WISE_API,
        null,
        certificate,
        {locationId: locationId,
          yyyyMmDd:yyyyMmDd},
        signal,
      );
    },
    ...options,
  });
};

export const RQDeleteEmployeeReport = ({id, certificate, signal}) => {
  return rqCreateRequest(
    RQ_DELETE_EMPLOYEE_REPORT_API,
    JSON.stringify({id}),
    certificate,
    {id},
    signal,
  );
};
